module.exports = __webpack_public_path__ + "img/visamaster.6c3098c5.png";